import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CookieConsentBanner from "@/components/ui/CookieConsentBanner";
import { disableAnalyticsTracking, loadAnalytics } from "@/lib/analytics";
import { getCookieConsentState } from "@/lib/cookieConsent";

// Lazy load all page components for better performance
const LandingPage = React.lazy(() => import("./pages/LandingPage"));
const PrivacyPage = React.lazy(() => import("./pages/PrivacyPage"));
const CookiesPage = React.lazy(() => import("./pages/CookiesPage"));
const NotFoundPage = React.lazy(() => import("./pages/NotFoundPage"));

const App: React.FC = () => {
  React.useEffect(() => {
    const consentState = getCookieConsentState();
    if (consentState === 'accepted') {
      loadAnalytics();
    } else {
      disableAnalyticsTracking();
    }
  }, []);

  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      <CookieConsentBanner />
    </Router>
  );
};

export default App;
